import { apiGet, apiPost } from '@jumbo/utils/ApiHelper';
import config from 'config';

const trackingUrl = config.trackingApiUrl;
const loadApiUrl = config.loadApiUrl;
const apiUrl = config.apiUrl;

export function getAllJourneysApi(data) {
  return apiGet(trackingUrl, 'journeys/active', data);
}

export function getJourneyApi(id) {
  return apiGet(trackingUrl, `journeys/${id}`);
}

export function getJourneysbyUserApi(data) {
  return apiGet(trackingUrl, 'journeys', data);
}

export function getJourneyByUserIdApi(id) {
  return apiGet(trackingUrl, `users/${id}/journey/latest`);
}

export function getLocationsbyJourneyIdApi(id) {
  return apiGet(trackingUrl, `journeys/${id}/locations/history`);
}

export function getAllCurrentDispatchesApi(params) {
  return apiGet(loadApiUrl, `admin/dispatches`, params);
}

export function getSelectedDispatchByIdApi(id) {
  return apiGet(loadApiUrl, `admin/dispatches/${id}`);
}

export function getSelectedDispatchByPublicIdApi(id) {
  return apiGet(loadApiUrl, `dispatches/public/${id}`);
}

export function getLatestLocationForLoadApi(id) {
  return apiGet(trackingUrl, `loads/${id}/locations/latest`);
}

export function getLatestLocationForMultipleLoadsApi(params) {
  return apiGet(trackingUrl, `loads/locations/latest`, params);
}

export function getDispatchesCountApi(params){
  return apiGet(loadApiUrl, 'admin/dispatches/count',params);
}

export function addCallLogForDispatchApi(dispatch_id, data){
  return apiPost(loadApiUrl, `admin/dispatches/${dispatch_id}/comments`, data);
}

export function getAdminDetailsByIdsApi(params){
  return apiGet(apiUrl, 'admin/api/admin-users', params);
}

export function getTrackingLoadsApi(data) {
  return apiGet(loadApiUrl, `admin/dispatches`, data)
}

export function getTruckLocationHistoryByLoadIdApi(loadId) {
  return apiGet(trackingUrl, `loads/${loadId}/locations/history`);
}
